@if (selectedAttributes) {
    <div class="header">
        <label>{{ title }}</label>
        <fa-icon [icon]="addIcon" class="fa-lg" (click)="onAddAttribute()"></fa-icon>
    </div>

    <div class="drop-list-container">
        <div id="items" cdkDropList [cdkDropListData]="selectedAttributes" class="drop-list" (cdkDropListDropped)="onDropAttribute($event)">
            @for (attribute of selectedAttributes; track attribute.id) {
                <div class="drop-item attribute-item" cdkDrag cdkDragPreview>
                    <fa-icon [icon]="dragIcon" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                    <span class="label">{{ attribute.header }}</span>
                    <fa-icon [icon]="deleteIcon" class="fa-lg delete-icon" (click)="onRemoveAttribute(attribute.id)"></fa-icon>
                </div>
            }
        </div>
    </div>
}
